var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 309,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.331 149.575c10.822 7.374 13.529 22.171 6.018 32.898-7.377 10.534-21.851 13.182-32.48 5.941l-3.442-2.345a23.407 23.407 0 01-4.069 16.39c-5.084 7.261-13.539 10.775-21.783 9.887l26.756 18.229c10.822 7.374 13.529 22.171 6.018 32.898-7.377 10.534-21.851 13.182-32.48 5.941l-.251-.171c1.984 6.64 1.027 14.094-3.262 20.22-7.38 10.538-21.862 13.184-32.49 5.934L11.125 184.394C.31 177.018-2.391 162.226 5.117 151.503c7.38-10.538 21.861-13.184 32.49-5.934l8.402 5.731c-1.925-6.602-.95-13.991 3.307-20.071 5.132-7.33 13.701-10.842 22.02-9.861L32.842 95.101C22.03 87.723 19.33 72.934 26.838 62.213c7.38-10.54 21.865-13.184 32.493-5.932l14.895 10.164a23.406 23.406 0 014.09-16.216c7.376-10.535 21.851-13.182 32.479-5.941l154.536 105.287z",
    fill: "#DFE9FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "onboarding5_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 40,
    width: 276,
    height: 260
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.331 149.575c10.822 7.374 13.529 22.171 6.018 32.898-7.377 10.534-21.851 13.182-32.48 5.941l-3.442-2.345a23.407 23.407 0 01-4.069 16.39c-5.084 7.261-13.539 10.775-21.783 9.887l26.756 18.229c10.822 7.374 13.529 22.171 6.018 32.898-7.377 10.534-21.851 13.182-32.48 5.941l-.251-.171c1.984 6.64 1.027 14.094-3.262 20.22-7.38 10.538-21.862 13.184-32.49 5.934L11.125 184.394C.31 177.018-2.391 162.226 5.117 151.503c7.38-10.538 21.861-13.184 32.49-5.934l8.402 5.731c-1.925-6.602-.95-13.991 3.307-20.071 5.132-7.33 13.701-10.842 22.02-9.861L32.842 95.101C22.03 87.723 19.33 72.934 26.838 62.213c7.38-10.54 21.865-13.184 32.493-5.932l14.895 10.164a23.406 23.406 0 014.09-16.216c7.376-10.535 21.851-13.182 32.479-5.941l154.536 105.287z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onboarding5_svg__filter0_d_0_7350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 164.82,
    width: 114,
    height: 54,
    rx: 10,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.028 193.117c.558-.639.837-1.395.837-2.268 0-.792-.29-1.478-.867-2.056-.579-.579-1.264-.869-2.056-.869h-4.218c.04-.142.081-.264.122-.365.04-.102.097-.213.167-.335a12.607 12.607 0 00.571-1.127c.097-.224.193-.528.29-.914a4.74 4.74 0 00.144-1.157c0-.244-.003-.442-.008-.594a6.573 6.573 0 00-.075-.685 3.843 3.843 0 00-.183-.762 3.56 3.56 0 00-.366-.685 2.144 2.144 0 00-.61-.617 3.333 3.333 0 00-.913-.395c-.37-.107-.79-.16-1.257-.16a.936.936 0 00-.685.289 2.65 2.65 0 00-.518.761 4.557 4.557 0 00-.297.792c-.056.224-.12.533-.19.929-.092.427-.16.734-.206.922a4.924 4.924 0 01-.266.738c-.132.305-.29.548-.472.731-.335.335-.848.944-1.538 1.827-.498.65-1.01 1.264-1.539 1.843-.528.579-.913.878-1.157.898a1.003 1.003 0 00-.655.313.916.916 0 00-.274.662v9.761c0 .264.097.49.29.678.192.188.42.287.685.297.355.01 1.157.233 2.406.67.782.264 1.393.464 1.835.601.441.137 1.058.284 1.85.442.792.157 1.522.236 2.192.236h1.965c1.35-.02 2.35-.416 3-1.187.588-.701.837-1.62.746-2.757.396-.375.67-.852.822-1.431.172-.619.172-1.213 0-1.782a3.159 3.159 0 00.655-2.086c.001-.325-.075-.711-.227-1.158z",
    fill: "#E8DBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.475 189.874h4.385c.264 0 .493.096.686.289.192.193.289.422.289.686v9.746a.936.936 0 01-.29.685.936.936 0 01-.685.289h-4.385a.936.936 0 01-.686-.289.938.938 0 01-.289-.685v-9.746c0-.264.096-.493.29-.686a.936.936 0 01.685-.289zm1.949 9.746a.948.948 0 00.685-.282.927.927 0 00.29-.693.936.936 0 00-.29-.685.935.935 0 00-.685-.289.928.928 0 00-.693.289.948.948 0 00-.282.685c0 .275.094.505.282.693a.94.94 0 00.693.282z",
    fill: "#E8DBFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FC",
    d: "M66.5 179.22h26.25v8H66.5zM66.5 189.241H119v8H66.5zM66.5 199.261h44v8h-44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.697 52.59h2.198v2.196a2.196 2.196 0 104.394 0V52.59h2.197a2.196 2.196 0 100-4.395h-2.197v-2.197a2.196 2.196 0 10-4.394 0v2.197h-2.198a2.196 2.196 0 00-2.197 2.198c0 1.214.983 2.197 2.197 2.197z",
    fill: "#FECFAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.197 9.59h2.197v2.196c0 1.215.983 2.198 2.198 2.198a2.196 2.196 0 002.197-2.198V9.59h2.197a2.196 2.196 0 002.198-2.197 2.196 2.196 0 00-2.198-2.197H58.79V2.997A2.196 2.196 0 0056.592.8a2.196 2.196 0 00-2.197 2.197v2.198h-2.198A2.196 2.196 0 0050 7.392c0 1.214.983 2.197 2.197 2.197z",
    fill: "#E0D7FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.197 144.089h2.197v2.197a2.196 2.196 0 104.395 0v-2.197h2.197a2.196 2.196 0 100-4.394H78.79v-2.198a2.196 2.196 0 00-2.197-2.197 2.196 2.196 0 00-2.198 2.197v2.198h-2.197a2.196 2.196 0 100 4.394z",
    fill: "#FECFAF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.032 118.222h2.344v2.197c0 1.215.983 2.197 2.197 2.197a2.196 2.196 0 002.198-2.197v-2.197h2.197a2.196 2.196 0 002.197-2.197 2.196 2.196 0 00-2.197-2.198h-2.197v-2.197a2.196 2.196 0 00-2.198-2.197 2.196 2.196 0 00-2.197 2.197v2.197h-2.344a2.196 2.196 0 00-2.197 2.198c0 1.214.983 2.197 2.197 2.197z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.775 43.8a4.591 4.591 0 11-9.183 0 4.592 4.592 0 019.183 0zM12.184 94.392a4.592 4.592 0 11-9.184 0 4.592 4.592 0 019.184 0z",
    stroke: "#E0D7FE",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.367 122.616a4.592 4.592 0 11-9.184 0 4.592 4.592 0 019.184 0z",
    stroke: "#FECFAF",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111 130.803c1.954 0 16.476-18.127 18.012-21.299A19.92 19.92 0 00131 100.8c0-11.046-8.954-20-20-20s-20 8.954-20 20c0 2.979.651 5.807 1.82 8.347 1.501 3.265 16.226 21.656 18.18 21.656z",
    fill: "#8F2EDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 105.8a5.5 5.5 0 100-11 5.5 5.5 0 100 11z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.887 218.82s-6.461-40.193-28.416-64.836C140.515 129.341 111 129.155 111 129.155",
    stroke: "#2E8DDE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "1 11"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.582 222.8a6.392 6.392 0 01-6.392-6.392v-54.631a6.392 6.392 0 0112.784 0v54.631a6.392 6.392 0 01-6.392 6.392z",
    fill: "#42464A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.152 222.8a6.392 6.392 0 01-6.392-6.392v-54.631a6.392 6.392 0 0112.784 0v54.631a6.392 6.392 0 01-6.392 6.392z",
    fill: "#50555A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.279 81.101a5.327 5.327 0 00-6.789 3.265l-7.401 21.112-16.484 8.793h-24.093c-7.024 0-12.767 5.626-12.802 12.569v39.132a5.327 5.327 0 0010.654 0l-.001-39.105c.006-1.017 1.029-1.942 2.149-1.942h.248v40.392h28.214v-41.303l18.962-10.114a5.328 5.328 0 002.52-2.937l8.087-23.073a5.326 5.326 0 00-3.264-6.789z",
    fill: "#FFB69E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M225.238 108.066l-11.633 6.205h-4.038c.116 3.001-2.671 5.552-5.581 5.552-3.119 0-5.429-2.541-5.578-5.552h-8.896c-7.024 0-12.767 5.626-12.801 12.569v11.474h10.653v-11.447c.005-1.017 1.029-1.942 2.148-1.942h.249v40.392h28.214v-41.303l12.552-6.695-5.289-9.253z",
    fill: "#414B82"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203.868 110.751c6.097 0 11.04-4.942 11.04-11.039 0-6.097-4.943-11.04-11.04-11.04-6.097 0-11.039 4.943-11.039 11.04 0 6.097 4.942 11.039 11.039 11.039z",
    fill: "#FFB69E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "onboarding5_svg__filter0_d_0_7350",
    x: 7,
    y: 154.82,
    width: 134,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.831373 0 0 0 0 0.831373 0 0 0 0 0.831373 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_7350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_7350",
    result: "shape"
  })))));
}
export default SvgOnboarding5;